
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/u/[user]",
      function () {
        return require("private-next-pages/u/[user]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/u/[user]"])
      });
    }
  